<template>
  <div id="app" :class="{'is_pc_box': is_pc_box, 'is_mobile_box': is_mobile_box, 'pc_class': platform_pc}">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
    name: 'app',
	data() {
		return{
			is_pc_box: false,
			is_mobile_box: false,
			platform_pc: false,  //pc
		}
	},
	created() {
		let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
		if(flag) {
			this.is_pc_box = false;
			this.is_mobile_box = true;
		}else {
			this.is_mobile_box = false;
			this.is_pc_box = true;
		}
		if(/iPad|iPod/i.test(navigator.userAgent)) {
		    this.platform_pc = true;
		}
	},
	mounted() {
		let that = this;
		/* window.onscroll = function() {
			console.log(document.documentElement.scrollTop);
			if(document.documentElement.scrollTop <= 0){
				that.noTouch = true;
			}
		} */
	},
}
</script>
<style>
@charset "utf-8";
::-webkit-input-placeholder{color:#999999;}
::-webkit-scrollbar{display:none;width:0 !important;height:0 !important;-webkit-appearance:none;background:transparent;}
*{margin:0;padding:0;font-family: "PFFont";outline:none;text-decoration:none;box-sizing:border-box;-webkit-tap-highlight-color:rgba(0,0,0,0);touch-action: pan-y;
font-size:0.4rem;}
img{vertical-align:top;}
html,body{width:100%;height:100%;margin:0px;padding:0px;-webkit-overflow-scrolling:touch;}ul li{list-style-type:disc;}
input,div,span,select,textarea,button{letter-spacing:0px;}
input{-webkit-appearance: none;}
a{}
/*loading*/
.loading{width:100%;height:100vh;position:absolute;display:flex;justify-content:center;align-items:center;top:0;right:0;bottom:0;left:0;background:#ffffff;z-index:999;}

.main{padding:0.64rem;word-break:keep-all;}
.main div{padding-bottom:0.32rem;}
.text_center{text-align:center;}
.text_right{text-align:right;}
.font-weight{font-weight:bold;}
.pad-bot-10{padding-bottom:0.213rem !important;}
.col-000{color:#000000;}
.pad-bot-15{padding-bottom:0.48rem !important;}
.tit_one{font-size:0.533rem;padding-bottom:0.533rem !important;font-weight:bold;color:#000000;}
.txt_box{/* text-indent:0.8rem; */line-height:1.5;}
ul{padding-left:0.4rem;margin:0 !important;}
ul li{text-indent:0;padding:0.1rem 0;}
.tit-li li{font-weight:bold;}
.tit-li li div{padding:0 !important;color:#16d0ff;text-decoration:underline;cursor:pointer;}
.van-toast *{color:#ffffff;}

.k-line{
	display: inline-block;
	width: 0.2rem;
	height: 0.2rem;
	border-radius: 50%;
	background-color: #761c1b;
	margin-left: 0.03rem;
}
@keyframes k-loadingA{
	50% {
		transform: translateY(-0.1rem);
	}
	100%{
		transform: translateY(0);
	}
}
.k-lineA-1{
	animation: k-loadingA 0.8s 0s infinite;
}
.k-lineA-2{
	animation: k-loadingA 0.8s infinite;
	-webkit-animation-delay:0.26s;
}
.k-lineA-3{
	animation: k-loadingA 0.8s infinite;
	-webkit-animation-delay:0.39s;
}
.k-lineA-4{
	animation: k-loadingA 0.8s infinite;
	-webkit-animation-delay:0.52s;
}



.is_pc_box{
	border-left:1px solid #f8f8f8;
	border-right:1px solid #f8f8f8;
	width: 700px;
	margin: 0 auto;
	position: relative;
}
.is_pc_box .fixed_top{
	position:fixed;
	bottom:1rem;
	margin-left: 580px;
	cursor:pointer;
	z-index:10;
	position: relative;
}
.is_mobile_box .fixed_top{
	position:fixed;
	bottom:1rem;
	right:1rem;
	cursor:pointer;
	z-index:1;
}

.col-red{
	color: #DD0010;
	font-weight: bold;
}
.col-pur{
	color: #720000;
	font-weight: bold;
}

/*pc端展示*/
.pc_class{width:13rem;margin:0 auto;background-color:#ffffff;position:relative;border-left:1px solid #f5f5f5;border-right:1px solid #f5f5f5;}
.pc_class .search_img{left:37%;}
.pc_class .ly-tab-active-bar{left:1.4rem;}

.van-button{
	height: 1.3rem !important;
	border-radius: 8px;
}
.van-button__text{
	font-size: 0.427rem;
}
</style>
